export default __webpack_public_path__ + "static/media/image.0aae5c2b.png";